import { render } from "./page-home.vue?vue&type=template&id=c2fb47ae"
import script from "./page-home.vue?vue&type=script&lang=js"
export * from "./page-home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__